/**
 * Order Bump Utility Functions
 * Pure functions for order bump data manipulation
 */

export interface OrderBumpOffer {
    id: string;
    name: string;
    description: string;
    price: number;
    currency: string;
    imageUrl?: string;
    isSelected?: boolean;
}

export interface OrderBumpPreview {
    offer: OrderBumpOffer;
    totalAmount: number;
    adjustedAmount: number;
}

export class OrderBumpUtils {
    /**
     * Check if order bump offer is valid
     */
    static isValidOffer(offer: OrderBumpOffer): boolean {
        return !!(offer.id && offer.name && offer.price > 0);
    }

    /**
     * Toggle order bump selection
     */
    static toggleSelection(offer: OrderBumpOffer): OrderBumpOffer {
        return {
            ...offer,
            isSelected: !offer.isSelected,
        };
    }

    /**
     * Calculate order bump preview
     */
    static calculatePreview(offer: OrderBumpOffer, baseAmount: number = 0): OrderBumpPreview {
        const totalAmount = baseAmount + offer.price;
        const adjustedAmount = offer.isSelected ? totalAmount : baseAmount;

        return {
            offer,
            totalAmount,
            adjustedAmount,
        };
    }

    /**
     * Get selected order bumps
     */
    static getSelectedOffers(offers: OrderBumpOffer[]): OrderBumpOffer[] {
        return offers.filter(offer => offer.isSelected);
    }

    /**
     * Get total for selected order bumps
     */
    static getSelectedTotal(offers: OrderBumpOffer[]): number {
        return offers
            .filter(offer => offer.isSelected)
            .reduce((total, offer) => total + offer.price, 0);
    }
}

